const items = [
  {
    name: 'Products',
    children: [
      {
        name: 'Product',
        path: '/product',
        icon: 'vertical_split'
      },
      {
        name: 'Production',
        path: '/production',
        icon: 'subject'
      },
      {
        name: 'Admin',
        path: '/admin',
        icon: 'admin_panel_settings'
      }
      // {
      //   name: 'New Product',
      //   path: '/production/new-product',
      //   icon: 'playlist_add'
      // },
      // {
      //   name: 'Products',
      //   path: '/production/products-configuration',
      //   icon: 'format_list_bulleted'
      // }
    ]
  },
  {
    name: 'DevTools',
    children: [
      // {
      //   name: 'Import Sync',
      //   path: '/import',
      //   icon: 'import_export'
      // },
      {
        name: 'Selector Console',
        path: '/selector',
        icon: 'queue_play_next'
      },
      // {
      //   name: 'New Selector Console',
      //   path: '/selector_new',
      //   icon: 'queue_play_next'
      // },
      {
        name: 'SpecsMatrix',
        path: '/specsmatrix',
        icon: 'grid_goldenratio'
      }
    ]
  }
]
export default items



// WEBPACK FOOTER //
// ./src/components/sidebar/navData.js